import { useHistory, useRouteMatch } from 'react-router-dom';
import { Box } from '@givebutter/primitives/box';
import { Button } from '@givebutter/primitives/button';
import { Separator } from '@givebutter/primitives/separator';
import { filterFieldsByType } from 'assets/js/pages/contacts/ContactForm';
import { getContactFormQueryParams } from 'assets/js/pages/contacts/contactFormParams';
import { CustomFieldDisplayValue } from 'components/custom-fields';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useCurrentContact } from 'customHooks/useCurrentContact';

const ContactCustomFieldsSection = () => {
    const history = useHistory();
    const match = useRouteMatch();
    const { accountId } = useCurrentAccount();
    const { data: contact } = useCurrentContact();
    const fields = filterFieldsByType(contact?.custom_fields ?? [], contact.type);

    return (
        <Box className={'flex flex-col'}>
            <div className={'flex items-center justify-between px-6 py-4'}>
                <p className={'text-lg font-medium'}>Custom Fields</p>
                {fields.length > 0 ? (
                    <Button
                        variant="none"
                        size="sm"
                        color="primary"
                        className="font-medium"
                        onClick={() =>
                            history.push({
                                pathname: `${match.url}/details/edit`,
                                search: getContactFormQueryParams({
                                    only: ['custom-fields'],
                                    autoFocus: 'customFields.field_1',
                                }),
                            })
                        }
                    >
                        Edit
                    </Button>
                ) : null}
            </div>
            <Separator />
            <div className={'grid grid-cols-4 gap-x-6 gap-y-3 px-6 py-4'}>
                {fields.length > 0 ? (
                    fields.map(field => (
                        <div key={field.id} className={'col-span-full md:col-span-2'}>
                            <p className={'text-sm text-gray-600'}>{field.title}</p>
                            <CustomFieldDisplayValue className={'break-words'} field={field} />
                        </div>
                    ))
                ) : (
                    <div className={'col-span-full flex flex-col items-center gap-4 p-2'}>
                        <p>You don't have any custom fields yet.</p>
                        <Button
                            variant="solid"
                            onClick={() => {
                                history.push(`/accounts/${accountId}/contacts/custom-fields`);
                            }}
                        >
                            Manage custom fields
                        </Button>
                    </div>
                )}
            </div>
        </Box>
    );
};

export { ContactCustomFieldsSection };
